import React, { Component } from 'react';
import { Badge, Icon } from './';
import CSSModules from 'react-css-modules';
import style from './tag-list.scss';

@CSSModules(style)
export default class TagList extends Component {
  state = {
    items: this.props.items
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ items: nextProps.items });
  }

  onDelete(index) {
    const items = [...this.state.items];
    items.splice(index, 1);
    if (this.props.onChange) this.props.onChange(items);
  }

  render() {
    const { items } = this.props;
    const content = items.map((item, index) => {
      return (
        <Badge type="weak">
          {item.label}
          <a onClick={() => this.onDelete(index)}>
            <Icon name="cross" />
          </a>
        </Badge>
      )
    });

    return (
      <div styleName="root">
        {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/tag-list.js